import { reactive } from 'vue'

const tabs = reactive([
  {
    name: '基本情報',
    required: true,
    status: 0,
    fields: ['info'],
  },
  // {
  //   name: '写真',
  //   required: true,
  //   status: 0,
  //   fields: ['picture'],
  // },
  // {
  //   name: 'パスワード',
  //   required: true,
  //   status: 0,
  //   fields: ['password'],
  // },
])

export const useProfileFormTabs = () => {
  return { tabs }
}